export default class PaAttnGroupController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnGroup/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnGroup/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/paAttnGroup/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnGroup/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnGroup/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnGroup/delete', 'post', params, axiosOption, httpOption);
  }

  static emptyUser (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnGroup/emptyUser', 'post', params, axiosOption, httpOption);
  }
  static adduser (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnGroup/adduser', 'post', params, axiosOption, httpOption);
  }
  static syncPaHoliday (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnGroup/syncPaHoliday', 'get', params, axiosOption, httpOption);
  }
}
